import type { Theme } from '@mui/material/styles';

const accountCardStyles = ({ spacing, palette }: Theme) => ({
  rootContainer: {
    marginBottom: spacing(3),
    padding: spacing(3),
    minWidth: '100%',
    overflow: 'hidden',
  },
  headerTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexGrow: 1,
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    alignItems: 'center',
  },
  buttonContainer: {
    display: 'flex',
    button: {
      textTransform: 'none',
    },
  },
  columnHeadersContainer: {
    paddingLeft: spacing(3),
    paddingRight: spacing(5),
    textAlign: 'center',
  },
  contentContainer: {
    marginTop: 15,
  },
  errorContainer: {
    backgroundColor: palette.error.light,
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'row',
    margin: `${spacing(4)} ${spacing(1)} 0`,
    padding: spacing(2),
  },
  errorTextContainer: {
    flex: 1,
    marginRight: spacing(2),
  },
  errorSecondaryText: {
    color: palette.text.secondary,
  },
  errorIcon: {
    //  position: 'absolute',
    color: palette.error.main,
    padding: '0 0 0 0',
    cursor: 'default',
    //  backgroundColor: 'inherit !important',
    marginBottom: 55,
    marginRight: 10,
  },
  errorSpinner: {
    margin: spacing(0, 4.5),
    alignSelf: 'center',
  },
  flexOne: {
    flex: 1,
    paddingRight: 0,
    paddingLeft: 0,
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  dialogContentInner: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  logo: {
    height: 64,
    width: 64,
    verticalAlign: 'sub',
    marginRight: spacing(1.25),
    backgroundColor: 'white',
    borderRadius: '100%',
    objectFit: 'contain',
    border: `solid 1px ${palette.border.main}`,
    '&.noLogo': {
      paddingBottom: 5,
    },
    '&.large': {
      height: 80,
      width: 80,
    },
  },
  plaidLogo: {
    height: spacing(7),
    background: 'none',
    borderRadius: '50%',
    boxShadow: `0px 0px 1px 1px ${palette.backdrop.dark}`,
  },
  errorActionButton: {
    alignSelf: 'center',
    marginLeft: spacing(1 / 2),
  },
  institutionTitleContainer: {
    marginLeft: 10,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  institutionUrl: {
    whiteSpace: 'nowrap',
    color: palette.text.secondary,
    fontSize: 14,
  },
  statusBanner: {
    margin: `${spacing(4)} ${spacing(1)} 0`,
  },
});

export default accountCardStyles;
